/** @format */

const template = `
<div class="row">
  <div class="col-md-12">
    <ng-transclude></ng-transclude>
    <sis-language-pills
      data-cy="localized-string-lang"
      [invalid-locales]="ctrl.invalidLangFields"
      [scope]="ctrl.scope"
      [(selected-language)]="ctrl.selectedLocale"></sis-language-pills>
    <div ng-if="ctrl.data && ctrl.selectedLocale" class="form-control-static text-area-static">{{ ctrl.data[ctrl.selectedLocale] }}</div>
  </div>
</div>
`;
export default template;
